var _ellipse, _polygon, _rect, _rect2, _rect3, _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _polygon2, _rect4, _path5, _path6, _rect5, _rect6, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _polygon3, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _polygon4, _circle15, _circle16, _path25, _circle17, _path26, _path27, _rect7, _rect8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeMain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 240.24,
    rx: 145.45,
    ry: 9.44,
    fill: "#e6e6e6",
    opacity: 0.45
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "175.73 171.83 164.73 229.16 218.39 229.16 207.39 171.83 175.73 171.83",
    fill: "#c9c9c9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 89.7,
    y: 50.32,
    width: 209.5,
    height: 136.34,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 157.39,
    y: 223.49,
    width: 68,
    height: 11.57,
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 89.7,
    y: 50.32,
    width: 209.5,
    height: 120.67,
    fill: "#fff",
    opacity: 0.56
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 105.79,
    cy: 62.59,
    r: 4.41,
    fill: "#24285b"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.9,
    cy: 62.59,
    r: 4.41,
    fill: "#68e1fd"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.25,
    cy: 62.59,
    r: 4.41,
    fill: "#ffd200"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M288.73,171c-.42,1.89-.87,3.78-1.33,5.66a34.88,34.88,0,0,1-3.65,10H258.07a2.5,2.5,0,0,1-.05-.29c-.09-.8,1.26-8.81,2.28-15.38.73-4.83,1.28-8.88.95-8.77-5.8,1.84-12.57,3.57-17.59.12a20.45,20.45,0,0,1-3.87-3.85l-23.71-28.36c-.88-1-1.75-2.69-.76-3.64s2.25-.25,3.27.35l11,6.49c3,1.75,7.58,5.86,11.08,6,5.58.3,13.64-5.69,16.89-9.81,3.74-4.74,5.75-10.64,6.79-16.59,1-5.57,1.39-11.78,5.39-15.78,2.73-2.72,7.16-4.65,7.26-8.5.12-4.58-4.43-8.66-1.43-13.35,3.47-5.44,9-1.79,10.29,3.07.95,3.65.84,7.49,1.17,11.24.67,7.57,3.18,14.84,4.73,22.27C295.81,131.38,293.15,151.54,288.73,171Z",
    fill: "#a5a5a5",
    opacity: 0.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.39,224.29s-8.32-2.27-10.13-10c0,0,12.89-2.61,13.26,10.7Z",
    fill: "#68e1fd",
    opacity: 0.58
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.41,223.47s-5.81-9.19-.7-17.78c0,0,9.8,6.22,5.45,17.8Z",
    fill: "#68e1fd",
    opacity: 0.73
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.91,223.47s3.07-9.7,12.35-11.54c0,0,1.74,6.3-6,11.57Z",
    fill: "#68e1fd"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "120.87 223.25 122.56 234.79 133.18 234.83 134.75 223.31 120.87 223.25",
    fill: "#24285b"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 63.75,
    y: 90.94,
    width: 59.09,
    height: 62.73,
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M244.72,109.45a2.58,2.58,0,0,0,1.62-1.9v-1c-.13-.62-.25-1.25-.41-1.86a13.52,13.52,0,0,0-2-4.63,5.77,5.77,0,0,0-.62-.69,2.41,2.41,0,0,0-2.76-.43,8.91,8.91,0,0,1-6.13.65,7.12,7.12,0,0,1-5-6,8,8,0,0,1,.6-4.06,7.49,7.49,0,0,0,.28-.92,1.57,1.57,0,0,0-.29-1.49,9.84,9.84,0,0,0-8-4,1.57,1.57,0,0,0-1.14.39,4.48,4.48,0,0,0-1.25,1.66,7.55,7.55,0,0,1-9.62,4.26,7.85,7.85,0,0,1-4.4-4.53,3.05,3.05,0,0,0-.13-.32,2.23,2.23,0,0,0-2.6-1.44,14.14,14.14,0,0,0-6.29,2.21,5.71,5.71,0,0,0-1,.84,2.5,2.5,0,0,0-.63,2.55,11.46,11.46,0,0,1-.24,6.76,6,6,0,0,1-4.17,3.77,8.26,8.26,0,0,1-5.4-.15c-.28-.1-.57-.17-.85-.27a2.15,2.15,0,0,0-2.35.61,7.52,7.52,0,0,0-1.51,2.19,12.19,12.19,0,0,0-1.37,4.89,3.61,3.61,0,0,0,.44,1.85,2.2,2.2,0,0,0,1.16,1.07,10.36,10.36,0,0,1,4,2.85,6.44,6.44,0,0,1,.27,8.2,9.77,9.77,0,0,1-4.16,3.28A2.45,2.45,0,0,0,179,126a7.52,7.52,0,0,0,.31,2.75A14.66,14.66,0,0,0,181.2,133a3.06,3.06,0,0,0,2.55,1.61,4,4,0,0,0,1.28-.19,10.63,10.63,0,0,1,5.73-.17,4.64,4.64,0,0,1,2.12,1.2,6.89,6.89,0,0,1,1.51,7.59c-.18.46-.39.9-.54,1.37a2.27,2.27,0,0,0,.46,2.28,8,8,0,0,0,2.34,1.83,15.67,15.67,0,0,0,5.4,1.85,5.07,5.07,0,0,0,1.29,0,2.56,2.56,0,0,0,2.1-1.71,8.61,8.61,0,0,1,3-3.9l.46-.32a6.77,6.77,0,0,1,2.52-1,7,7,0,0,1,6.11,2,9.44,9.44,0,0,1,2.11,3.14,3.58,3.58,0,0,0,1.1,1.46,2.11,2.11,0,0,0,1.63.39,13.46,13.46,0,0,0,6.65-2.62,3,3,0,0,0,1-3.74,7.49,7.49,0,0,1-.05-6.36,6,6,0,0,1,5.06-3.72,10.24,10.24,0,0,1,4.64.47,3.68,3.68,0,0,0,4.13-1.22,11.11,11.11,0,0,0,2.25-5.06,10.58,10.58,0,0,0,.15-1.6,2.54,2.54,0,0,0-.92-2.07,4.94,4.94,0,0,0-1.37-.88,7.35,7.35,0,0,1-2.5-11.9A8.83,8.83,0,0,1,244.72,109.45Zm-26.6,26.46a19.94,19.94,0,0,1-5.6.79,19.6,19.6,0,0,1-7.78-1.6,20,20,0,1,1,13.38.81Z",
    fill: "#c9c9c9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.35,137.55a1.7,1.7,0,0,0,1.54-.63l.3-.58c.11-.41.23-.82.32-1.23a8.76,8.76,0,0,0,.21-3.38,3.1,3.1,0,0,0-.15-.6,1.59,1.59,0,0,0-1.51-1.1,6,6,0,0,1-3.86-1.5,4.76,4.76,0,0,1-1.14-5.14,5.23,5.23,0,0,1,1.6-2.23,4.89,4.89,0,0,0,.45-.46,1.06,1.06,0,0,0,.28-1,7.38,7.38,0,0,0-.42-1.48,7.59,7.59,0,0,0-3.14-3.35,1.07,1.07,0,0,0-.8-.12,2.93,2.93,0,0,0-1.25.61,5.07,5.07,0,0,1-7-.41,5.26,5.26,0,0,1-1.23-4c0-.08,0-.15,0-.23a1.5,1.5,0,0,0-1.1-1.66,9.71,9.71,0,0,0-4.43-.61,3.62,3.62,0,0,0-.85.2,1.67,1.67,0,0,0-1.16,1.32,7.64,7.64,0,0,1-2.21,4,4,4,0,0,1-3.64,1,5.55,5.55,0,0,1-3.17-1.75l-.43-.42a1.44,1.44,0,0,0-1.58-.36,4.88,4.88,0,0,0-1.57.85,8.12,8.12,0,0,0-2.32,2.49,2.42,2.42,0,0,0-.3,1.24,1.46,1.46,0,0,0,.36,1,7,7,0,0,1,1.48,2.9,4.3,4.3,0,0,1-2.35,5,6.5,6.5,0,0,1-3.49.68,1.63,1.63,0,0,0-1.62.82,4.93,4.93,0,0,0-.66,1.73,10,10,0,0,0-.19,3.09,2.05,2.05,0,0,0,1,1.74,2.42,2.42,0,0,0,.82.28,7.15,7.15,0,0,1,3.47,1.66,3,3,0,0,1,.89,1.36,4.62,4.62,0,0,1-1.42,5c-.25.21-.51.41-.75.65a1.53,1.53,0,0,0-.42,1.5,5.32,5.32,0,0,0,.83,1.81,10.82,10.82,0,0,0,2.65,2.75,3.13,3.13,0,0,0,.78.38,1.7,1.7,0,0,0,1.77-.37,5.77,5.77,0,0,1,3-1.39,2.52,2.52,0,0,1,.37-.05,4.38,4.38,0,0,1,1.81.18,4.64,4.64,0,0,1,3,3,6.11,6.11,0,0,1,.3,2.51,2.5,2.5,0,0,0,.2,1.21,1.42,1.42,0,0,0,.86.73,9,9,0,0,0,4.76.48,2,2,0,0,0,1.73-1.92,5,5,0,0,1,1.92-3.81,4.05,4.05,0,0,1,4.16-.67,6.86,6.86,0,0,1,2.61,1.71,2.47,2.47,0,0,0,2.84.53,7.41,7.41,0,0,0,2.89-2.32,7.67,7.67,0,0,0,.58-.9,1.73,1.73,0,0,0,.09-1.52,3.47,3.47,0,0,0-.55-.95,4.92,4.92,0,0,1,2.16-7.85A6.11,6.11,0,0,1,176.35,137.55Zm-24,7.62a13.39,13.39,0,0,1-3.58-1.25,13,13,0,0,1-4.14-3.33,13.55,13.55,0,0,1-1.58-14.75,13.42,13.42,0,1,1,9.3,19.33Z",
    fill: "#c9c9c9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 74.08,
    y: 140.31,
    width: 38.42,
    height: 2.68,
    fill: "#a5a5a5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 81.33,
    y: 140.31,
    width: 23.92,
    height: 2.68,
    fill: "#fff",
    opacity: 0.23
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.03,
    cy: 108.77,
    r: 3.73,
    fill: "#a5a5a5",
    opacity: 0.02
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.16,
    cy: 127.64,
    r: 3.73,
    fill: "#a5a5a5",
    opacity: 0.36
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.03,
    cy: 127.64,
    r: 3.73,
    fill: "#a5a5a5",
    opacity: 0.16
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.16,
    cy: 108.77,
    r: 3.73,
    fill: "#a5a5a5",
    opacity: 0.84
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.47,
    cy: 132.03,
    r: 3.73,
    fill: "#a5a5a5",
    opacity: 0.23
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.47,
    cy: 105.35,
    r: 3.73,
    fill: "#a5a5a5"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.95,
    cy: 118.51,
    r: 3.73,
    fill: "#a5a5a5",
    opacity: 0.52
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.64,
    cy: 118.51,
    r: 3.73,
    fill: "#a5a5a5",
    opacity: 0.09
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.55,
    cy: 95.33,
    r: 1.22,
    fill: "#a5a5a5",
    opacity: 0.23
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.08,
    cy: 95.33,
    r: 1.22,
    fill: "#a5a5a5",
    opacity: 0.23
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.62,
    cy: 95.33,
    r: 1.22,
    fill: "#a5a5a5",
    opacity: 0.23
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M222,127.41a17.94,17.94,0,0,1-3.09-3.29c-.66-1.22-1.51-5.35-2.54-5.25s.19,2.44,0,4.69-1.22-.84-1.69.28.85,2.44,1.69,3.57a56.19,56.19,0,0,0,5,4.5Z",
    fill: "#f4a28c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M264.58,104.22s-13.59,34-18.84,32.12-24.38-10.51-24.38-10.51l-2,4.92s19.39,26.6,31,22.09,27.15-28,27.15-28Z",
    fill: "#68e1fd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M264.58,104.22s-13.59,34-18.84,32.12-24.38-10.51-24.38-10.51l-2,4.92s19.39,26.6,31,22.09,27.15-28,27.15-28Z",
    fill: "#fff",
    opacity: 0.46
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M270.08,237.37s-1.17,3.1-4,3.29-3.6,2.94-1.08,3.69,9.09-2.39,9.09-2.39L274,236.8Z",
    fill: "#68e1fd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M306.7,236.8s-.74,3.67-3.56,3.86-3.59,2.94-1.07,3.69,9.09-2.39,9.09-2.39L311,236.8Z",
    fill: "#68e1fd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M282.18,94.65l8.85.28s27.31,1.91,31.45,17.95-14.83,54-14.83,54H271.83S240.84,97.37,282.18,94.65Z",
    fill: "#68e1fd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M282.18,94.65s-.65,34.64-.54,34.14S291,94.93,291,94.93Z",
    fill: "#24285b"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M281.89,75.58a30.08,30.08,0,0,0-.56,8.1,2.44,2.44,0,0,0,2.77,2.11,5.42,5.42,0,0,0,4.69-3.55l2-4.07a4.4,4.4,0,0,0-1.37-4.89C286.87,71,282.35,72.63,281.89,75.58Z",
    fill: "#f4a28c"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "290.39 78.91 291.03 94.93 282.18 94.65 285.27 83.1 290.39 78.91",
    fill: "#f4a28c"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M283.07,75.92a19.06,19.06,0,0,0,4.52.19,4.07,4.07,0,0,0-.53,4.44,3.32,3.32,0,0,0,3.83,1.79l.66-6.25a5,5,0,0,0-2-4.71,16.84,16.84,0,0,0-2-1.26c-1.71-.94-4.48-.05-6-1.45a1.18,1.18,0,0,0-1.95.54c-.51,1.87-.52,4.9,1.92,6.24A4.57,4.57,0,0,0,283.07,75.92Z",
    fill: "#24285b"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M307.65,166.86s-4.81,35,5,69.94h-7.27s-13-20.6-16.31-63.12Z",
    fill: "#24285b"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M286.56,80.35s.25-1.87,1.64-1.56,1,3-.91,3Z",
    fill: "#f4a28c"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M281.42,78.63l-1.58,1.71a.78.78,0,0,0,.34,1.28l1.82.57Z",
    fill: "#f4a28c"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M284.48,85.6a5.85,5.85,0,0,0,3-1.36s-.47,2.9-4,5.39Z",
    fill: "#ce8172",
    opacity: 0.31
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M271.83,166.86s-8.75,49.89-3.25,69.94h7.05s2.43-46.26,14.32-57.06l17.7-12.88Z",
    fill: "#24285b"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M306.55,105.83s-14.54,5.53-6.61,27.86,5,25-3.38,23.51c-4.45-.78-7.59-7-9.53-10.52-1.55-2.8-2.75-5.76-4.24-8.59-1.3-2.47-4.73-2.38-7.17-2.24q-6.37.35-12.7,1a4.64,4.64,0,0,0,2.2,2.76,36.54,36.54,0,0,0,6.77,3.79,11.37,11.37,0,0,0,5.64.86s-1.16,17,8,22.59h22.14l11.53-12V124.74Z",
    opacity: 0.08
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M308.05,104.43a7.42,7.42,0,0,1,9.86.72c4.92,5,11.77,16.34,8.84,38.9-4.41,33.93-27.83,33.44-47.12-1.1l5.88-3.75s17.66,24.46,25.37,12.34C317.88,140.54,294.44,115.08,308.05,104.43Z",
    fill: "#68e1fd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M308.05,104.43a7.42,7.42,0,0,1,9.86.72c4.92,5,11.77,16.34,8.84,38.9-4.41,33.93-27.83,33.44-47.12-1.1l5.88-3.75s17.66,24.46,25.37,12.34C317.88,140.54,294.44,115.08,308.05,104.43Z",
    fill: "#fff",
    opacity: 0.46
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M284.61,139.78a11,11,0,0,0-1-2.14,3.87,3.87,0,0,0-2.77-1.19l-2.45-.24a6.36,6.36,0,0,0-3.07.21,1.4,1.4,0,0,0-1,1.26,1.24,1.24,0,0,0,.87.95,6.69,6.69,0,0,0,1.34.22,5.52,5.52,0,0,1,4.31,3.34Z",
    fill: "#f4a28c"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "241.18 138.14 236.82 113.53 267.69 113.53 270.37 134.51 284.53 134.71 284.53 138.14 241.18 138.14",
    fill: "#ffd200"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 253.47,
    cy: 125.33,
    r: 3.09,
    fill: "#fff"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 288.47,
    cy: 80.02,
    r: 1.81,
    fill: "#c9c9c9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M288.18,80.41s-.74,5.28-2.66,6.12a5.31,5.31,0,0,1-3.88,0",
    fill: "none",
    stroke: "#c9c9c9",
    strokeMiterlimit: 10
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.59,
    cy: 86.59,
    r: 0.77,
    fill: "#c9c9c9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M291.59,75.39l-12-9.62s.22-.42,1.19.21,4.69,3.31,4.69,3.31,1.52-2.53,4.77-.21S292.9,73.82,291.59,75.39Z",
    fill: "#68e1fd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M287.8,80s2-6.85,1.76-8.64a8,8,0,0,0-1.38-3.25A3,3,0,0,1,291,69.67s2,2.27-1.62,10.62Z",
    fill: "#c9c9c9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 290.28,
    y: 115.34,
    width: 9.48,
    height: 6.9,
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 294.6,
    y: 114.4,
    width: 1.41,
    height: 2.35,
    opacity: 0.08
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMain);
export default __webpack_public_path__ + "static/media/home-main.d9c16fc815a5c8402d0ec9e54eb5110b.svg";
export { ForwardRef as ReactComponent };